
import { ref, onBeforeMount, getCurrentInstance, provide, nextTick, reactive, watch, computed } from 'vue'
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import { refreshTokenApi } from '@/hooks/index'
import { sensors } from '@/plugins/sensors'
import fbeventsFn from '@/plugins/fbevents'
import GAFn from '@/plugins/GA'
import { useRoute } from "vue-router";
import { loginFn } from '@/hooks/index'
import {useStore} from '@/main'
export default {
  components: {
    HelloWorld,
  },
  setup(props: object) {
    const Store:any =  useStore();
    const route: any = useRoute();
    const internalInstance = getCurrentInstance()
    const http = internalInstance?.appContext.config.globalProperties.$http || {}
    const store = internalInstance?.appContext.config.globalProperties.store || {}
    const facebook_appId = internalInstance?.appContext.config.globalProperties.$get_facebook_appId || {}
    sensors(store)
    fbeventsFn()
    GAFn()
    provide('$http', http)
    // app内
    const is_lite = Boolean(window.androidWebObject)
    if (navigator.userAgent.indexOf("kilimall,android") > -1 && !is_lite) {
      //app 首次进入 清除token 以便重新获取
     // if (common.getStorage('kong_access_token')) common.delStorage('kong_access_token')
      if(common.getStorage('access_token')) {
        common.delStorage('access_token')
        common.delStorage("user_info")
      }
      try {
        let token = window.appBean.obtainAccessToken()
        if (token) {
          common.setStorage('access_token', token)
        }
      } catch (error) {
        if (window.WebViewJavascriptBridge) {
          window.WebViewJavascriptBridge.callHandler('submitFromWeb', { 'action': 'obtainAccessToken' }, (responseData: any) => {
            if (responseData) {
              common.setStorage("access_token", responseData);
            }
          });
        } else {
          document.addEventListener('WebViewJavascriptBridgeReady', () => {
            window.WebViewJavascriptBridge.callHandler('submitFromWeb', { 'action': 'obtainAccessToken' }, (responseData: any) => {
              if (responseData) {
                common.setStorage("access_token", responseData);
              }
            });
          });
        }
      }

    }

    provide('$store', reactive(store))
    provide('$get_facebook_appId', facebook_appId)
    internalInstance?.appContext.config.globalProperties.$sa.quick('autoTrack', {
      platform_type: sessionStorage.getItem('source') === 'byteApp' ? 'byteApp' : "Wap",
      client_name: 'NewWap'
    })
    let htmlBox: any = ref(null)
    nextTick(() => {
      htmlBox.value.style.setProperty('--max_height', document.documentElement.clientHeight + 'px')
    })
    if (!common.getStorage('access_token') && common.getStorage('refresh_token')) { // token过期，从新获取token
      refreshTokenApi(http)
    }
    
    const view_update_sa_pageview_fn = (): void => {
      internalInstance?.appContext.config.globalProperties.$sa.quick('autoTrackSinglePage', {
        platform_type: sessionStorage.getItem('source') === 'byteApp' ? 'byteApp' : "Wap",
        client_name: 'NewWap'
      })
    }
    let keepAliveList = computed(() => {
       return Store.keepAliveList
    })
    watch(() => route.path, () => {
      view_update_sa_pageview_fn(); // 路由更改掉用神策记录浏览事件 $pageview
      var start_time = new Date()
      common.setStorage('start_time', start_time.getTime())
      const item_obj: any = document.querySelector('body')
      if (item_obj != null && item_obj.classList.contains('van-overflow-hidden')) item_obj.classList.remove("van-overflow-hidden");
    })
    if (common.getStorage('access_token') && !common.getStorage('user_info')) {
      let token_obj: any = {
        access_token: common.getStorage('access_token'),
        kong_access_token: common.getStorage('kong_access_token')
      }
      loginFn(token_obj, http, '');
    }
    return {
      htmlBox,
      route,
      keepAliveList
    }
  },

  beforeCreate: function () {
    // 在页面头部以同步的方式加载 js 代码
    var start_time = new Date()
    common.setStorage('start_time', start_time.getTime())
    // 定义起始时间
    var end_time = ''
    // 定义结束时间
  },
}
